import { render, staticRenderFns } from "./template-master-item.vue?vue&type=template&id=570e5e1d&scoped=true"
import script from "./template-master-item.vue?vue&type=script&lang=js"
export * from "./template-master-item.vue?vue&type=script&lang=js"
import style0 from "./template-master-item.vue?vue&type=style&index=0&id=570e5e1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e5e1d",
  null
  
)

export default component.exports